import {pxToRem} from '../../../utills/pxToRem'
import colors from '../../foundations/colors'
import {fonts} from '../../foundations/fonts'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {},
        socialsContainer: {
            flex: 1,
            justifyContent: 'flex-start',
            border: '1px solid pink'
        },
        icon: {
            color: 'pink',
            width: 5,
            height: 5
        },
        logo: {
            width: 12,
            height: 8
        },
        socialsItem: {
            textAlign: 'center',
            paddingLeft: 2,
            paddingRight: 2
        },
        actions: {
            paddingLeft: 4,
            paddingRight: 4
        },
        actionsItem: {
            paddingTop: 3,
            paddingBottom: 3
        },
        localeSelector: {
            paddingTop: 1,
            paddingBottom: 1
        },
        signout: {
            width: '100%',
            paddingLeft: 8,
            paddingTop: 2,
            paddingBottom: 2,
            _focus: {
                borderRadius: 0,
                boxShadow: 'outline'
            }
        },
        signoutText: {
            marginLeft: 2,
            fontSize: 14,
            fontWeight: 'normal'
        },
        drawerOverlay: {
            backgroundColor: 'transparent'
        },
        drawerContent: {
            width: `${pxToRem(300)} !important`,
            top: `${pxToRem(221)} !important`, // important is needed to override chakra ui top placement
            height: `calc(100dvh - ${pxToRem(220)})`
        },
        drawerContentWithoutPromoBanner: {
            width: `${pxToRem(300)} !important`,
            top: `${pxToRem(177)} !important`, // important is needed to override chakra ui top placement
            height: `calc(100dvh - ${pxToRem(175)})`
        },
        drawerContentSticky: {
            width: `${pxToRem(300)} !important`,
            top: `${pxToRem(145)} !important`, // important is needed to override chakra ui top placement
            height: `calc(100dvh - ${pxToRem(145)})`
        },
        drawerBody: {
            paddingBottom: pxToRem(40),
            paddingTop: pxToRem(0),
            paddingLeft: pxToRem(0),
            paddingRight: pxToRem(0)
        },
        actionMenu: {
            marginLeft: `${pxToRem(20)}`,
            marginRight: `${pxToRem(20)}`,
            marginTop: `${pxToRem(0)}`,
            marginBottom: `${pxToRem(20)}`,
            paddingTop: pxToRem(10),
            borderTop: `${pxToRem(2)} solid ${colors.cav_mobile_nav_border_black}`
        },
        mobileFeatureImage: {
            width: '50%',
            marginTop: [pxToRem(20), pxToRem(20), pxToRem(20), pxToRem(20)],
            marginRight: ['auto', 'auto', 'auto', 'auto'],
            marginBottom: [pxToRem(0), pxToRem(0), pxToRem(0), pxToRem(0)],
            marginLeft: ['auto', 'auto', 'auto', 'auto']
        },
        actionMenuItem: {
            padding: pxToRem(0),
            margin: pxToRem(0)
        },
        actionMenuItemLink: {
            padding: pxToRem(3),
            lineHeight: pxToRem(20),
            fontWeight: '400',
            fontFamily: fonts.primary,
            letterSpacing: pxToRem(2),
            fontSize: pxToRem(14),
            _hover: {
                textDecoration: 'none'
            }
        }
    },
    parts: [
        'actions',
        'actionsItem',
        'container',
        'icon',
        'localeSelector',
        'socials',
        'socialsItem',
        'signout',
        'drawerContent',
        'drawerContentWithoutPromoBanner',
        'drawerContentSticky',
        'drawerOverlay',
        'drawerBody',
        'actionMenu',
        'actionMenuItem',
        'actionMenuItemLink',
        'mobileFeatureImage'
    ]
}
